"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var Ajax = {
	get: function get(url, func) {
		//开始css效果
		this.showLoading();
		jQuery.ajax({
			url: url,
			method: "GET",
			contentType: "application/json",
			dataType: 'json',
			success: function success(data) {
				// 取消css效果
				--mimironUse.ajaxLoadingStack == 0 ? $("#ajax-loading") ? $("#ajax-loading").removeClass("la-animate") : null : null;
				if (data["info"] && data["autoWrap"]) data = data.autoWrap;
				func(data);
			},
			error: this.onError,
			complete: function complete() {} });
	},
	//注意, 不能在complete中调用取消css的方法,因为func(data)可能报错.
	post: function post(url, params, func) {
		this.showLoading();
		jQuery.ajax({
			url: url,
			method: "POST",
			data: JSON.stringify(params),
			contentType: "application/json",
			dataType: 'json',
			success: function success(data) {
				// 取消css效果
				--mimironUse.ajaxLoadingStack == 0 ? $("#ajax-loading") ? $("#ajax-loading").removeClass("la-animate") : null : null;
				if (data["info"] && data["autoWrap"]) data = data.autoWrap;
				func(data);
			},
			error: this.onError,
			complete: function complete() {}
		});
	},
	form: function form(url, params) {
		var form = $("<form>");
		form.attr("style", "display:none");
		form.attr("target", "");
		form.attr("method", "post");
		form.attr("action", url);
		$("body").append(form);
		var input1 = $("<input>");
		input1.attr("type", "hidden");
		input1.attr("name", "params");
		input1.attr("value", JSON.stringify(params));
		form.append(input1);
		form.submit();
		form.remove();
	},

	showLoading: function showLoading() {
		mimironUse.ajaxLoadingStack = mimironUse.ajaxLoadingStack || 0;
		mimironUse.ajaxLoadingStack++;
		$("#ajax-loading") ? $("#ajax-loading").addClass("la-animate") : null;
	},
	onError: function onError(obj, msg, e) {
		// 取消css效果
		--mimironUse.ajaxLoadingStack == 0 ? $("#ajax-loading") ? $("#ajax-loading").removeClass("la-animate") : null : null;
		console.info(msg, e);
	}
};

exports["default"] = Ajax;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/tools/ajax.js
 ** module id = 629
 ** module chunks = 0
 **/